module.exports = __webpack_public_path__ + "static/media/galeria5.075fb626.jpg";